import { Download } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { TabContext } from "@mui/lab";
import {
  CircularProgress,
  Grid2,
  IconButton,
  MenuItem,
  Slide,
  Tab,
  TableCell,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import parsePhoneNumber from "libphonenumber-js";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useMeasure from "react-use-measure";
import countries from "world-countries";
import * as Yup from "yup";
import BasicInfoIco from "../../../../assets/icons/BasicInfoIco";
import CopyIco from "../../../../assets/icons/CopyIco";
import CRMAttachmentIco from "../../../../assets/icons/CRMAttachment";
import CRMCandidateIco from "../../../../assets/icons/CRMCandidateIco";
import CRMNotesIco from "../../../../assets/icons/CRMNotesIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import EyeIco from "../../../../assets/icons/EyeIco";
import JobSowIco from "../../../../assets/icons/JobSowIco";
import KeyContactIco from "../../../../assets/icons/KeyContactIco";
import RatingStarIco from "../../../../assets/icons/RatingStarIco";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import CRMHailey from "../../../../assets/images/CRMHailey.svg";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import CommonButton from "../../../../component/Button";
import SnackBar from "../../../../component/SnackBar";
import { ClientGetCall } from "../../../../redux/action/ClientPartner";
import { JobIndustryList } from "../../../../redux/action/Job";
import {
  CRMAttachementCreateCall,
  CRMAttachementDelete,
  CRMAttachementDownload,
  CRMAttachementTableGetCall,
  CRMNoteAdd,
  CRMNoteAddUpdate,
  CRMNoteDelete,
  CRMNoteGet,
  UpdateeNewRelationshipCall,
} from "../../../../redux/action/VendorPartner";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import CommonAccordion from "../../../common-components/CommonAccordion";
import SkillDeleteDialog from "../../../common-components/DeleteDialog";
import DeleteNote from "../../../common-components/DeleteNote";
import {
  CommonGrid2,
  CustomTooltip,
  DotColor,
  ScoreChange,
  StatusChange,
  StyledFlexRowView,
  TabPanelView,
} from "../../../common-components/StyledComponents";
import { FlagImage, FormattedCountry } from "../../../crm/client-partner/style";
import AddNote from "../../../jobs/job-information/Dialog/Notes";
import Notes from "../../../jobs/job-information/notes";
import AttachmentDialog from "../../../jobs/jobs-candidate/components/AttachementDialog";
import Attachment from "../../../jobs/jobs-candidate/components/Attachment";
import BasicInfo from "../../../jobs/jobs-candidate/components/BasicInfo";
import {
  CustomizeMenu,
  CustomizeSpan,
  TabCardSection,
} from "../../../jobs/style";
import AddNewContact from "./components/AddNewContact";
import ApiRender from "./components/ApiRender";
import Candidate from "./components/Candidate";
import JobSow from "./components/JobSow";
import KeyContact from "./components/KeyContact";
import ViewBasicInfo from "./components/ViewBasicInfo";

// const steps = [
//   {
//     selector: ".step-1",
//     content:
//       "Welcome! 👋 Here you can add the client's contact information including name, email, and phone number. Make sure all fields are filled correctly before proceeding.",
//   },
//   {
//     selector: ".step-2",
//     content:
//       "This section allows you to view all the jobs associated with the selected client. ",
//   },
//   {
//     selector: ".step-3",
//     content:
//       "Here you can see all candidates linked to this client. Easily track their progress, update statuses, and manage candidate details.",
//   },
//   {
//     selector: ".step-4",
//     content:
//       "Need to upload important files? Use this section to add attachments like resumes, agreements, or any supporting documents related to the client.",
//   },
//   {
//     selector: ".step-5",
//     content:
//       "Finally, this section helps you record important notes about the client. Add quick reminders or detailed comments to keep everything organized.",
//   },
// ];

const AppContent = () => {
  const [copied, setCopied] = useState(false);
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const [contact, setContact] = useState({
    open: false,
    loading: false,
    data: {},
    download: false,
    view: false,
    deleteOpen: false,
    deleteBtnLoading: false,
    form: {
      setFieldValue: "",
      values: "",
    },
    unique_id: "",
    rating: 0,
    status: "",
  });
  const navigate = useNavigate();
  const [attachmentList, setAttachmentList] = useState({
    data: [],
    loading: false,
    download: false,
    view: false,
    attachementRowData: {},
  });
  const [notes, setNotes] = useState({
    open: false,
    loading: true,
    data: [],
    deleteNote: false,
    noteData: {},
    headerData: [
      { name: "Title", direction: "asc", sort: false, width: "40%" },
      { name: "Created By", direction: "asc", sort: false, width: "25%" },
      { name: "Date", direction: "asc", sort: false, width: "20%" },
      { width: "15%" },
    ],
    btnLoading: false,
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [btnChange, setBtnChange] = useState({
    value: "Edit",
    loading: false,
  });
  const [attachmentAnchorEl, setAttachmentAnchorEl] = useState(null);
  const attachementOpen = Boolean(attachmentAnchorEl);
  const [contactAnchorEl, setContactAnchorEl] = useState(null);
  const contactOpen = Boolean(contactAnchorEl);
  const [attachmentDialog, setAttachmentDialog] = useState({
    loading: false,
    disabled: false,
    open: false,
  });
  const [deleteButton, setDeleteButton] = useState({
    loading: false,
    open: false,
    content: "",
    id: "",
  });
  const [ref, bounds] = useMeasure();
  const [isLoading, setIsLoading] = useState(true);
  const headerData = {
    keyHeader: [
      { name: "Name" },
      { name: "Type" },
      { name: "Email Address" },
      { name: "Phone Number" },
      { name: "NPS" },
      { name: "Action" },
    ],
    jobHeader: [
      { name: "Unique Id" },
      { name: "Req Id" },
      { name: "Job Title" },
      { name: "Type" },
      { name: "Status" },
      { name: "Client" },
      { name: "Created" },
      {},
    ],
    candidateHeader: [
      { name: "Id" },
      { name: "Name" },
      { name: "Title" },
      { name: "Status" },
      { name: "Score" },
      { name: "Type" },
      { name: "Last Activity" },
      {},
    ],
  };
  const cardDataDetails = [
    {
      name: "Key Contacts",
      icon: <KeyContactIco />,
    },
    {
      name: "Jobs & SOWs",
      icon: <JobSowIco />,
    },
    {
      name: "Candidates",
      icon: <CRMCandidateIco />,
    },
    {
      name: "Attachment",
      icon: <CRMAttachmentIco />,
    },
    {
      name: "Notes",
      icon: <CRMNotesIco />,
    },
  ];
  const [cardData, setCardData] = useState(cardDataDetails);
  const [cardValue, setCardValue] = useState({ value: 0, prev: 0 });
  const query = new URLSearchParams(useLocation().search);
  const getId = query.get("id");
  const getType = query.get("type");
  const breadCrumbData = [
    {
      title: query.get("type"),
      navigate: query.get("type") === "Client" ? `/client` : `/vendor`,
    },

    {
      title: query.get("title"),
      active: true,
    },
  ];
  const attachementHeaderData = [
    { name: "Name", width: "23%" },
    { name: "Type", width: "20%" },
    { name: "Status" },
    { name: "Created by" },
    { name: "Created Date" },
    {},
  ];

  const initialValues = {
    name: "",
    country: "",
    flag: "",
    country_data: countries.map((country) => {
      return {
        name: `${country.name.common}`,
      };
    }),
    email: "",
    industry: "",
    available_industry: [],
    primary_time_zone: "",
    primary_time_zone_data: [
      { name: "Eastern Standard Time(EST)" },
      { name: "Central Standard Time(CST)" },
      { name: "Mountain Standard Time(MST)" },
      { name: "Pacific Standard Time(PST)" },
      { name: "Indian Standard Time(IST)" },
      { name: "Gulf Standard Time(GST)" },
      { name: "Greenwich Standard Time(GST)" },
    ],
    website: "",
    contact_number: "",
    phone_country: "",
    currency_status: "",
    currency_status_data: [
      { id: "0", name: "Dollar (USD)" },
      { id: "1", name: "Euro (EUR)" },
      { id: "2", name: "Rupee (INR)" },
    ],
    vms: "",
    hub_cities: "",
    contact: [],
    hub_cities_value: "",
  };

  const basicInfoData = [
    ...(getType === "Client" || getType === "Partner"
      ? [
          {
            title: "Business Name",
            component: "input",
            titleName: "name",
            placeholder: "Enter the Name",
            placeholderFontSize: "15px",
            mandatory: true,
          },
          {
            title: "Country",
            component: "single-auto-complete",
            titleName: "country",
            placeholder: "Select the Country",
            dropDownData: "country_data",
            placeholderFontSize: "15px",
            mandatory: true,
          },
          {
            title: "Email Address",
            component: "input",
            titleName: "email",
            placeholder: "Enter the Email Address",
            placeholderFontSize: "15px",
            mandatory: true,
          },
          {
            title: "Mobile Number",
            component: "phone-number",
            fontSize: "15px",
            country: "phone_country",
            titleName: "contact_number",
            placeholder: "Enter the Mobile Number",
            placeholderFontSize: "15px",
            mandatory: false,
          },

          ...(getType === "Client"
            ? [
                {
                  title: "Hub Cities",
                  component: "autoComplete",
                  titleName: "hub_cities",
                  placeholder: "Enter Cities",
                  inputValue: "hub_cities_value",
                  mandatory: true,
                },

                {
                  title: "VMS",
                  component: "input",
                  titleName: "vms",
                  placeholder: "Enter VMS",
                  placeholderFontSize: "15px",
                  mandatory: false,
                },
                {
                  title: "Primary Time Zone",
                  component: "dropDown",
                  titleName: "primary_time_zone",
                  dropDownData: "primary_time_zone_data",
                  placeholder: "Select Time Zone",
                  mandatory: true,
                },

                {
                  title: "Website",
                  component: "input",
                  titleName: "website",
                  placeholder: "Enter the Website",
                  placeholderFontSize: "15px",
                  mandatory: true,
                },
                {
                  title: "Industry",
                  component: "multi-complete",
                  titleName: "industry",
                  options: "available_industry",
                  placeholder: "Select the Industry",
                  valueChange: true,
                  mandatory: true,
                },
                {
                  title: "Currency",
                  component: "multi-complete",
                  titleName: "currency_status",
                  options: "currency_status_data",
                  placeholder: "Select the Currency",
                  valueChange: true,
                  mandatory: true,
                },
              ]
            : []),
          {
            title: "Rating",
            component: "slider",
            titleName: "rating",
            placeholderFontSize: "15px",
            mandatory: false,
          },
        ]
      : []),
  ];

  const handleCopyMouseLeave = () => {
    setTimeout(() => setCopied(false), 200);
  };

  const handleCopyClick = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch (error) {}
  };

  const handleCardChange = (event, newValue) => {
    setCardValue({ value: newValue, prev: cardValue.value });
  };

  const handleAttachment = () => {
    setAttachmentDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleAttachmentClose = () => {
    setAttachmentDialog({
      loading: false,
      disabled: false,
      open: false,
    });
  };

  const handleAttachmentSubmit = async (values, { setFieldValue }) => {
    try {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: false,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: true,
        disabled: true,
      }));

      const formData = new FormData();

      values.file.forEach((fileObj) => {
        formData.append("file", fileObj.file);
      });
      formData.append("name", values.name);
      let type = query.get("type") === "Client" ? "client" : "partner";
      const data = await CRMAttachementCreateCall(type, getId, formData);
      await fetchAttachmentTableList(getId);
      handleAttachmentClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: true,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: false,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleIconClick = (event, rowData) => {
    setAttachmentList((prev) => ({
      ...prev,
      attachementRowData: rowData,
    }));
    setAttachmentAnchorEl(event.currentTarget);
  };

  const handleAttachmentTableBodyData = (row, index) => (
    <>
      <TableCell>
        <CommonGrid2 display={"flex"} gap={"5px"} alignItems={"ceter"}>
          {row.name || "-"}
          {row.is_new && (
            <CustomizeSpan
              background={"#F7F1FF"}
              width="max-content"
              border={"1px solid #EAECF0"}
              padding="2px 8px"
              color={"#6941C6"}
              fontSize="12px"
              fontWeight={700}
              borderRadius="50px"
              display={"flex"}
              alignItems="center"
            >
              Active
            </CustomizeSpan>
          )}
        </CommonGrid2>
      </TableCell>
      <TableCell>{row.type || "-"}</TableCell>
      <TableCell>{row.status || "-"}</TableCell>
      <TableCell>{row.created_by || "-"}</TableCell>
      <TableCell>
        {moment(row.created_at).format("DD MMM YYYY") || "-"}
      </TableCell>
      <TableCell>
        <MoreVertOutlinedIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => handleIconClick(e, row)}
        />

        <CustomizeMenu
          id="basic-menu"
          anchorEl={attachmentAnchorEl}
          open={attachementOpen}
          onClose={() => setAttachmentAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {attachmentMenuData.map((item, index) => (
            <MenuItem
              key={index}
              onClick={item.disabled ? () => {} : item.onClick}
              aria-controls={item.ariaControls}
              aria-haspopup={item.ariaHasPopup}
              aria-expanded={item.ariaExpanded}
              style={{ opacity: item.disabled ? 0.5 : 1 }}
              disabled={item?.disabled}
            >
              <StyledFlexRowView>
                {item.image}
                <Typography>{item.title}</Typography>
              </StyledFlexRowView>
            </MenuItem>
          ))}
        </CustomizeMenu>
      </TableCell>
    </>
  );

  const handelAttachmentDialogClose = () => {
    setDeleteButton({
      loading: false,
      open: false,
      content: "",
      id: "",
    });
  };

  const handleDownloadAttachment = async () => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        download: true,
      }));
      let type = query.get("type") === "Client" ? "client" : "partner";
      const response = await CRMAttachementDownload(
        type,
        attachmentList.attachementRowData.id,
      );
      let filename = attachmentList.attachementRowData.file_name || "download";
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);

      setAttachmentList((prev) => ({
        ...prev,
        download: false,
      }));
      setAttachmentAnchorEl(null);
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        download: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAttachmentClick = () => {
    setAttachmentAnchorEl(null);
    setDeleteButton((prev) => ({
      ...prev,
      open: true,
      id: attachmentList.attachementRowData.id,
      content: attachmentList.attachementRowData.name,
    }));
  };

  const fetchAttachmentTableList = async (getId) => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        loading: true,
      }));
      let type = query.get("type") === "Client" ? "client" : "partner";
      const data = await CRMAttachementTableGetCall(type, getId);
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
        data: data?.data,
      }));
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAttachment = async () => {
    try {
      setDeleteButton((prev) => ({
        ...prev,
        loading: true,
      }));
      let type = query.get("type") === "Client" ? "client" : "partner";
      const data = await CRMAttachementDelete(type, deleteButton?.id);
      await fetchAttachmentTableList(getId);
      handelAttachmentDialogClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setDeleteButton((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleFileView = async () => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        view: true,
      }));
      let type = query.get("type") === "Client" ? "client" : "partner";
      const response = await CRMAttachementDownload(
        type,
        attachmentList.attachementRowData.id,
      );
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        attachmentList.attachementRowData.file_path,
      )}`;
      const isDocValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["doc", "docx"].includes(ext);
      };
      const isPdfValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["pdf"].includes(ext);
      };
      if (isDocValidFile(attachmentList.attachementRowData.file_name)) {
        window.open(officeViewerUrl, "_blank");
      } else if (isPdfValidFile(attachmentList.attachementRowData.file_name)) {
        window.open(blobUrl, "_blank");
      }
      setAttachmentAnchorEl(null);
      setAttachmentList((prev) => ({
        ...prev,
        view: false,
      }));
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        view: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const attachmentMenuData = [
    {
      title: "View",
      disabled: attachmentList.view || attachmentList.download,
      image: attachmentList.view ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <EyeIco />
      ),
      onClick: () => {
        handleFileView();
      },
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      disabled: attachmentList.download || attachmentList.view,
      onClick: handleDeleteAttachmentClick,
    },
    {
      title: "Download",
      disabled: attachmentList.download || attachmentList.view,
      image: attachmentList.download ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "20px" }} />
      ),
      onClick: handleDownloadAttachment,
    },
  ];

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleClickAddNote = () => {
    setNotes((prev) => ({
      ...prev,
      open: true,
      noteData: {},
    }));
  };

  useEffect(() => {
    const functionCall = async () => {
      await fetchNote(getId);
      await fetchAttachmentTableList(getId);
    };
    functionCall();
  }, []);

  const fetchNote = async (getId) => {
    try {
      setNotes((prev) => ({
        ...prev,
        loading: true,
      }));
      let type = query.get("type") === "Client" ? "client" : "partner";
      const data = await CRMNoteGet(type, getId);
      setNotes((prev) => ({
        ...prev,
        loading: false,
        data: data?.data,
      }));
    } catch (error) {
      setNotes((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteNote = (row) => {
    setNotes((prev) => ({
      ...prev,
      open: false,
      deleteNote: true,
      noteData: row,
    }));
  };

  const handleUpdateNote = (row) => {
    setNotes((prev) => ({
      ...prev,
      open: true,
      noteData: row,
    }));
  };

  const handleCloseNoteDialog = () => {
    setNotes((prev) => ({
      ...prev,
      open: false,
      deleteNote: false,
      noteData: {},
      btnLoading: false,
      loading: false,
    }));
  };

  const handleCreateNote = async (values) => {
    try {
      setNotes((prev) => ({
        ...prev,
        btnLoading: true,
      }));
      let payload = {};
      if (notes.noteData?.id) {
        payload = {
          note: values,
        };
      } else {
        payload = [{ note: values }];
      }
      let type = query.get("type") === "Client" ? "client" : "partner";
      let getData = {};
      if (notes.noteData?.id) {
        getData = await CRMNoteAddUpdate(type, notes.noteData?.id, payload);
      } else {
        getData = await CRMNoteAdd(type, getId, payload);
      }

      await fetchNote(getId);
      setSnackbarState({
        open: true,
        message: getData.message,
        severity: "success",
      });

      setNotes((prev) => ({
        ...prev,
        btnLoading: false,
        open: false,
        noteData: {},
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });

      setNotes((prev) => ({
        ...prev,
        btnLoading: false,
      }));
    }
  };

  const handleDeleteNoteById = async (row) => {
    try {
      setNotes((prev) => ({
        ...prev,
        btnLoading: true,
      }));

      let type = query.get("type") === "Client" ? "client" : "partner";

      const getData = await CRMNoteDelete(type, notes.noteData?.id);
      await fetchNote(getId);
      handleCloseNoteDialog();
      setSnackbarState({
        open: true,
        message: getData.message,
        severity: "success",
      });
    } catch (error) {
      setNotes((prev) => ({
        ...prev,
        btnLoading: false,
      }));
    }
  };

  const handleContactView = () => {
    setContact((prev) => ({
      ...prev,
      view: true,
    }));
    setTimeout(() => {
      setContactAnchorEl(null);
      setContact((prev) => ({
        ...prev,
        open: true,
        view: false,
      }));
    }, 1000);
  };

  const handleContactDeleteClick = () => {
    setContact((prev) => ({
      ...prev,
      delete: true,
    }));
    setTimeout(() => {
      setContactAnchorEl(null);
      setContact((prev) => ({
        ...prev,
        deleteOpen: true,
        delete: false,
      }));
    }, 1000);
  };

  const handleContactPrimary = () => {
    setContact((prev) => ({
      ...prev,
      primary: true,
    }));
    setTimeout(() => {
      setContactAnchorEl(null);
      const getData = contact.form.values.map((item) =>
        item.id === contact.data.id
          ? { ...item, primary_contact: true }
          : { ...item, primary_contact: false },
      );
      contact.form.setFieldValue("contact", getData);
      setContact((prev) => ({
        ...prev,

        primary: false,
      }));
    }, 1000);
  };

  const ContactMenuData = [
    {
      title: "View",
      disabled: contact.view || contact.download || contact.primary,
      image: contact.view ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <EyeIco />
      ),
      onClick: () => {
        handleContactView();
      },
    },
    {
      title: "Delete",
      image: contact.delete ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <DeleteIco />
      ),
      disabled: contact.download || contact.view || contact.primary,
      onClick: handleContactDeleteClick,
    },
    {
      title: "Set as Primary",
      disabled: contact.view || contact.download || contact.primary,
      image: contact.primary ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <TaskAltIcon sx={{ fontSize: "20px" }} />
      ),
      onClick: handleContactPrimary,
    },
  ];

  const handleKeyContactIconClick = (event, rowData, setFieldValue, values) => {
    setContact((prev) => ({
      ...prev,
      data: rowData,
      form: {
        setFieldValue: setFieldValue,
        values: values,
      },
    }));
    // setAttachmentList((prev) => ({
    //   ...prev,
    //   attachementRowData: rowData,
    // }));
    setContactAnchorEl(event.currentTarget);
  };

  const handleTableBodyData = (row, setFieldValue, values) => (
    <Fragment>
      <TableCell>
        <CommonGrid2 display={"flex"} gap={"5px"} alignItems={"ceter"}>
          {row.name}
          {row.primary_contact && (
            <CustomizeSpan
              background={"#36A41D"}
              width="max-content"
              padding="2px 8px"
              color={"#fff"}
              fontSize="12px"
              fontWeight={700}
              borderRadius="50px"
              display={"flex"}
              alignItems="center"
            >
              Primary
            </CustomizeSpan>
          )}
        </CommonGrid2>
      </TableCell>
      <TableCell>{row.type || "-"}</TableCell>
      <TableCell>
        {" "}
        <CommonGrid2 display={"flex"} gap={"10px"}>
          {row.email || "-"}
          <CustomTooltip
            arrow
            placement="top"
            title={copied ? "Copied!" : "Copy to Clipboard"}
            fontSize="12px"
            padding="5px 10px"
            margin="0px 0px 10px !important"
          >
            <IconButton
              onClick={() => handleCopyClick(row?.email)}
              style={{ padding: "0px" }}
              onMouseLeave={handleCopyMouseLeave}
            >
              <CopyIco />
            </IconButton>
          </CustomTooltip>
        </CommonGrid2>
      </TableCell>
      <TableCell>
        <CommonGrid2 display={"flex"} gap={"10px"}>
          {row.contact_number === "" ? (
            "-"
          ) : (
            <Fragment>
              {"+" + row.contact_number || "-"}
              <CustomTooltip
                arrow
                placement="top"
                title={copied ? "Copied!" : "Copy to Clipboard"}
                fontSize="12px"
                padding="5px 10px"
                margin="0px 0px 10px !important"
              >
                <IconButton
                  onClick={() => handleCopyClick(row?.contact_number)}
                  style={{ padding: "0px" }}
                  onMouseLeave={handleCopyMouseLeave}
                >
                  <CopyIco />
                </IconButton>
              </CustomTooltip>
            </Fragment>
          )}
        </CommonGrid2>
      </TableCell>
      <TableCell>
        <CommonGrid2
          background="#ECFDF3"
          border={"1px solid #AAEFC6"}
          padding={"2px 8px"}
          borderRadius={"50px"}
          color={"#067647"}
          fontSize={"13px"}
          width={"max-content"}
        >
          {row.nps_score || 0}/5
        </CommonGrid2>
      </TableCell>
      <TableCell>
        <MoreVertOutlinedIcon
          style={{
            cursor: btnChange.value === "Edit" ? "auto" : "pointer",
            fill: btnChange.value === "Edit" && "#ababab",
          }}
          onClick={(e) =>
            btnChange.value === "Edit"
              ? {}
              : handleKeyContactIconClick(e, row, setFieldValue, values)
          }
        />

        <CustomizeMenu
          id="basic-menu"
          anchorEl={contactAnchorEl}
          open={contactOpen}
          onClose={() => setContactAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {ContactMenuData.map((item, index) => (
            <MenuItem
              key={index}
              onClick={item.disabled ? () => {} : item.onClick}
              aria-controls={item.ariaControls}
              aria-haspopup={item.ariaHasPopup}
              aria-expanded={item.ariaExpanded}
              style={{ opacity: item.disabled ? 0.5 : 1 }}
              disabled={item?.disabled}
            >
              <StyledFlexRowView>
                {item.image}
                <Typography>{item.title}</Typography>
              </StyledFlexRowView>
            </MenuItem>
          ))}
        </CustomizeMenu>
      </TableCell>
    </Fragment>
  );

  const handleJobIconClick = (data) => {
    if (data.status === "Draft") {
      navigate(
        `/jobs/new-job?id=${data.job_data__id}&title=${data.job_title}&value=0`,
      );
    } else if (data.type === "Job") {
      navigate(
        `/jobs/jobs-view?id=${data.job_data__id}&title=${data.job_title}&value=0`,
      );
    } else {
      navigate(
        `/judica/judica-view?id=${data.job_data__id}&title=${data.job_title}&value=0`,
      );
    }
  };

  const handleCandidateIconClick = (row) => {
    navigate(`/candidates/candidate-view?view-id=${row.r_id || row.id}`);
  };

  const handleJobTableBodyData = (row) => (
    <Fragment>
      <TableCell>{row.job_data__order_no || "-"}</TableCell>
      <TableCell>{row.req_id || "-"}</TableCell>
      <TableCell>{row.job_title || "-"}</TableCell>
      <TableCell>{row.type || "-"}</TableCell>
      <TableCell>
        <StatusChange>
          <DotColor
            color={
              row.job_data__status === "Active"
                ? "#17B26A"
                : row.job_data__status === "Hold"
                  ? "orange"
                  : row.job_data__status === "Filled"
                    ? "#9E77ED"
                    : row.job_data__status === "Draft"
                      ? "#667085"
                      : "#F04438"
            }
          />
          {row.job_data__status || ""}
        </StatusChange>
      </TableCell>
      <TableCell>{row.company_name || "-"}</TableCell>
      <TableCell>
        {row.job_data__created_at
          ? moment(row.job_data__created_at).format("MMM DD, YYYY")
          : "-"}
      </TableCell>
      <TableCell>
        <VisibilityOutlinedIcon
          onClick={() => handleJobIconClick(row)}
          style={{ cursor: "pointer" }}
        />
      </TableCell>
    </Fragment>
  );

  const handleCandidateTableBodyData = (row) => (
    <Fragment>
      <TableCell>{row.r_order_no || row.order_no || "-"}</TableCell>
      <TableCell>
        {row?.r_personal_details?.candidate_first_name +
          row?.r_personal_details?.candidate_last_name ||
          row?.personal_details?.candidate_first_name +
            row?.personal_details?.candidate_last_name ||
          "-"}
      </TableCell>
      <TableCell>
        {row?.r_personal_details?.title || row?.personal_details?.title || "-"}
      </TableCell>
      <TableCell>
        <StatusChange>
          <DotColor
            color={
              row.r_status || row.status === "Active"
                ? "#17B26A"
                : row.r_status || row.status === "Hold"
                  ? "orange"
                  : row.r_status || row.status === "Filled"
                    ? "#9E77ED"
                    : row.r_status || row.status === "Draft"
                      ? "#667085"
                      : "#F04438"
            }
          />
          {row.r_status || row.status || ""}
        </StatusChange>
      </TableCell>
      <TableCell>
        <ScoreChange>
          {row?.r_score?.overall_score ||
            row?.resume_score?.overall_score ||
            "-"}
          %
        </ScoreChange>
      </TableCell>
      <TableCell>{row.r_type || row.type || "-"}</TableCell>
      <TableCell>
        {row.r_created_at || row.created_at
          ? moment(row.r_created_at || row.created_at).format("MMM DD, YYYY")
          : "-"}
      </TableCell>

      <TableCell>
        <VisibilityOutlinedIcon
          onClick={() => handleCandidateIconClick(row)}
          style={{ cursor: "pointer" }}
        />
      </TableCell>
    </Fragment>
  );

  const handleAddNewContact = () => {
    setContact({
      open: true,
      loading: false,
      data: {},
      download: false,
      view: false,
      delete: false,
      deleteOpen: false,
      deleteBtnLoading: false,
      primary: false,
      form: {
        setFieldValue: "",
        values: "",
      },
      unique_id: "",
      rating: 0,
      status: "",
    });
  };

  const handleButttonClose = () => {
    setContact((prev) => ({
      ...prev,
      open: false,
      loading: false,
      data: {},
      view: false,
      download: false,
      deleteBtnLoading: false,
      deleteOpen: false,
      form: {
        setFieldValue: "",
        values: "",
      },
    }));
  };

  const handleInformation = (data, setFieldValue, values) => {
    let getData = [];
    if (contact.data?.id) {
      getData = values.contact.map((item, index) => {
        if (index + 1 === contact.data.id) {
          return { ...item, ...data };
        }
        return item;
      });
    } else {
      getData = [...values?.contact, data];
    }
    getData = getData.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
    setContact((prev) => ({
      ...prev,
      loading: true,
    }));
    setTimeout(() => {
      setFieldValue("contact", getData);
      handleButttonClose();
    }, 1000);
  };

  const handleDeleteKeyContact = () => {
    setContact((prev) => ({
      ...prev,
      deleteBtnLoading: true,
    }));
    setTimeout(() => {
      let data = contact.form.values.filter(
        (item) => item.id !== contact.data.id,
      );
      contact.form.setFieldValue("contact", data);
      handleButttonClose();
    }, 1000);
  };

  const handleButtonChange = () => {
    setBtnChange((prev) => ({
      ...prev,
      loading: true,
    }));
    setTimeout(() => {
      setIsLoading(false);
      setBtnChange((prev) => ({
        ...prev,
        loading: false,
        value: prev.value === "Edit" ? "Submit" : "Edit",
      }));
    }, 1000);
  };
  const PhoneWithFlag = ({ phone, flag, onCopy }) => {
    if (!phone) return "-";

    const str = phone.toString();
    const local = str.slice(-10);
    const dial = str.slice(0, str.length - 10);
    const formatted = `+${dial} ${local}`;

    return (
      <FlagImage>
        {flag && (
          <img
            src={flag}
            alt="flag"
            width={20}
            height={14}
            style={{ borderRadius: "2px" }}
          />
        )}
        <FormattedCountry>{formatted}</FormattedCountry>
        <CustomTooltip
          arrow
          placement="top"
          title={copied ? "Copied!" : "Copy to Clipboard"}
          fontSize="12px"
          padding="5px 10px"
          margin="0px 0px 10px !important"
        >
          <IconButton
            onClick={() => handleCopyClick(formatted)}
            style={{ padding: "0px" }}
            onMouseLeave={handleCopyMouseLeave}
          >
            <CopyIco />
          </IconButton>
        </CustomTooltip>
      </FlagImage>
    );
  };

  const handleFetchCall = async (setValues, values) => {
    try {
      setIsLoading(true);

      const listData = await JobIndustryList();
      const type = getType === "Client" ? "client" : "partner";
      const data = await ClientGetCall(type, getId);

      setValues({
        ...values,
        ...data?.data,
        available_industry: listData || [],
        name: data?.data?.primary_info?.name,
        country: data?.data?.primary_info?.country?.name,
        flag: data?.data?.primary_info?.country?.flag,
        email: data?.data?.primary_info?.email,
        industry:
          listData?.filter((item) =>
            (Array.isArray(data?.data?.primary_info?.industry)
              ? data.data.primary_info.industry
              : []
            ).some((check) => check === item?.name),
          ) || [],

        currency_status:
          values?.currency_status_data?.filter((item) =>
            (Array.isArray(data?.data?.primary_info?.currency_status)
              ? data.data.primary_info.currency_status
              : []
            ).some((check) => check === item?.name),
          ) || [],
        primary_time_zone: data?.data?.primary_info?.primary_time_zone,
        website: data?.data?.primary_info?.website,
        contact_number: data?.data?.primary_info?.contact_number,

        contact: data?.data?.key_contacts || [],
        unique_id: data?.data?.unique_id || "",
        rating: data?.data?.rating,
        status: data?.data?.status,
        hub_cities:
          data?.data?.primary_info?.hub_cities &&
          data?.data?.primary_info?.hub_cities.length === 0
            ? []
            : data?.data?.primary_info?.hub_cities?.map((item) => ({
                content: item,
              })),
        vms: data?.data?.primary_info?.vms,
      });
      setIsLoading(false);
      localStorage.setItem("crm-step-view", false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setIsLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    ...(getType === "Client"
      ? {
          name: Yup.string().required("Name is required"),
          country: Yup.string().required("Country is required"),
          email: Yup.string()
            .required("Email is required")
            .matches(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              "Invalid email address",
            ),
          primary_time_zone: Yup.string().required("Time Zone is required"),
          website: Yup.string().required("Website is required"),
          contact_number: Yup.string()
            .nullable()
            .test(
              "match-country",
              "Selected phone country does not match the user's country",
              function (value) {
                const { phone_country, country } = this.parent;

                if (!value) return true; // optional field
                if (!phone_country || !phone_country.name) return true;

                // Check: phone_country.name === country
                console.log(
                  phone_country.name,
                  country,
                  "phone_country.name === country",
                );
                return phone_country.name === country;
              },
            )
            .test(
              "is-valid-phone",
              "Phone number is not valid for the selected country",
              function (value) {
                const { phone_country } = this.parent;

                if (!value) return true; // optional field
                if (!phone_country?.countryCode) return true;

                const formattedValue = value.startsWith("+")
                  ? value
                  : `+${value}`;

                const phoneNumber = parsePhoneNumber(
                  formattedValue,
                  phone_country.countryCode,
                );

                return phoneNumber?.isValid();
              },
            ),

          // contact_number: Yup.string().required("Mobile Number is required"),
          currency_status: Yup.array()
            .min(1, "At least one currency is required")
            .required("Currency is required"),
          industry: Yup.array()
            .min(1, "At least one industry is required")
            .required("Industry is required"),
          hub_cities: Yup.array()
            .nullable()
            .of(
              Yup.object().shape({
                content: Yup.string().required("Cities name is required"),
              }),
            )
            .min(1, "At least one cities is required")
            .test(
              "unique-content",
              "Cities List must be unique",
              function (value) {
                if (!value || value.length === 0) return false;
                const contentSet = new Set();
                for (let location of value) {
                  if (location.content) {
                    const lowercasedContent = location.content.toLowerCase();
                    if (contentSet.has(lowercasedContent)) {
                      return false;
                    }
                    contentSet.add(lowercasedContent);
                  }
                }
                return true;
              },
            ),
        }
      : {
          name: Yup.string().required("Type is required"),
          country: Yup.string().required("Name is required"),
          email: Yup.string()
            .required("Email is required")
            .matches(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              "Invalid email address",
            ),
          contact_number: Yup.string()
            .nullable()
            .test(
              "match-country",
              "Selected phone country does not match the user's country",
              function (value) {
                const { phone_country, country } = this.parent;

                if (!value) return true; // optional field
                if (!phone_country || !phone_country.name) return true;

                // Check: phone_country.name === country
                console.log(
                  phone_country.name,
                  country,
                  "phone_country.name === country",
                );
                return phone_country.name === country;
              },
            )
            .test(
              "is-valid-phone",
              "Phone number is not valid for the selected country",
              function (value) {
                const { phone_country } = this.parent;

                if (!value) return true; // optional field
                if (!phone_country?.countryCode) return true;

                const formattedValue = value.startsWith("+")
                  ? value
                  : `+${value}`;

                const phoneNumber = parsePhoneNumber(
                  formattedValue,
                  phone_country.countryCode,
                );

                return phoneNumber?.isValid();
              },
            ),
          // contact_number: Yup.string().required("Mobile Number is required"),
        }),
  });

  const accordionDataView = [
    {
      title: "Key Contacts",
      component: (
        <KeyContact
          headerData={headerData}
          isLoading={isLoading}
          handleTableBodyData={handleTableBodyData}
        />
      ),
    },
    {
      title: "Jobs & SOWs",
      component: (
        <JobSow
          headerData={headerData.jobHeader}
          isLoading={isLoading}
          handleTableBodyData={handleJobTableBodyData}
          handleViewClick={handleJobIconClick}
        />
      ),
    },
    {
      title: "Candidates",
      component: (
        <Candidate
          headerData={headerData.candidateHeader}
          isLoading={isLoading}
          handleTableBodyData={handleCandidateTableBodyData}
          handleViewClick={handleCandidateIconClick}
        />
      ),
    },
    {
      title: "",
      component: (
        <Attachment
          tableData={attachmentList?.data}
          attachementHeaderData={attachementHeaderData}
          handleAttachment={handleAttachment}
          handleAttachmentTableBodyData={handleAttachmentTableBodyData}
          isLoading={isLoading || attachmentList.loading}
        />
      ),
    },
    {
      title: "Notes",
      component: (
        <Notes
          handleClickAddNote={handleClickAddNote}
          handleDeleteNoteClick={handleDeleteNote}
          handleUpdateNoteClick={handleUpdateNote}
          notesTableList={notes.data}
          notesTableListLoading={isLoading || notes.loading}
          isLoading={isLoading || notes.loading}
          headerData={notes.headerData}
        />
      ),
    },
  ];

  const handleSubmit = async (values, setValues) => {
    try {
      setBtnChange((prev) => ({
        ...prev,
        loading: true,
      }));
      let payload = {};
      if (getType === "Client") {
        payload = {
          client_name: values.name,
          contact_details: values.contact,
          rating: values.rating,
          hub_cities: values?.hub_cities?.map((item) => item.content),
          country: values.country,
          email: values.email,
          vms: values.vms,
          primary_time_zone: values.primary_time_zone,
          website: values.website,
          contact_number: values.contact_number,
          industry: values?.industry?.map((item) => item.id) || [],
          currency_status:
            values?.currency_status?.map((item) => item.name) || [],
          rating: values.rating,
          phone_country: values.phone_country,
        };
      } else {
        payload = {
          business_name: values.name,
          country: values.country,
          email: values.email,
          contact_number: values.contact_number,
          rating: values.rating,
          contact_details: values.contact,
          phone_country: values.phone_country,
        };
      }
      const data = await UpdateeNewRelationshipCall(
        getType === "Client" ? "client" : "partner",
        getId,
        payload,
      );
      await handleFetchCall(setValues, values);
      setBtnChange((prev) => ({
        ...prev,
        value: "Edit",
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setBtnChange((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  // const { setIsOpen } = useTour(); // ✅ correct destructuring

  // useEffect(() => {
  //   if (localStorage.getItem("crm-step-view") === "false") {
  //     setIsOpen(false);
  //   } else {
  //     const timer = setTimeout(() => setIsOpen(true), 300);
  //     return () => clearTimeout(timer);
  //   }
  // }, [setIsOpen]);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("crm-step-view") === null) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, []);

  const handleStepButttonClose = () => {
    localStorage.setItem("crm-step-view", false);
    setIsOpen(false);
  };

  console.log(localStorage.getItem("crm-step-view"), "sfskjfnskjfnsjknfsjkn");
  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setValues }) => handleSubmit(values, setValues)}
      >
        {({ validateForm, values, errors, setFieldValue, handleSubmit }) => {
          let section_1_data = [];
          if (getType === "Client") {
            section_1_data = [
              {
                title: "Business Name",
                content: values?.name || "-",
              },
              {
                title: "Primary Country",
                content: values?.country || "-",
                icon: values?.flag,
              },
              {
                title: "Email Address",
                copyContent: values?.email || "-",
              },
              {
                title: "Mobile Number",
                // copyContent: formatPhoneForCopy(values?.contact_number),
                content: (
                  <PhoneWithFlag
                    phone={values?.contact_number}
                    country={values?.country?.name}
                    flag={values?.flag}
                  />
                ),
              },

              // Section-2
              {
                title: "Primary Time Zone",
                content: values?.primary_time_zone || "-",
              },
              {
                title: "Industry",
                content_split: values?.industry || [],
              },
              {
                title: "Hub Cities",
                content_split: values?.hub_cities || [],
              },
              { title: "Website", content: values?.website || "-" },
              {
                title: "VMS",
                content: values?.vms || "-",
              },
              {
                title: "Currency",
                content_split: values?.currency_status || [],
              },
            ];
          } else {
            section_1_data = [
              {
                title: "Organization Name",
                content: values?.name || "-",
              },
              {
                title: "Primary Country",
                content: values?.country || "-",
                icon: values?.flag,
              },
              {
                title: "Email Address",
                copyContent: values?.email || "-",
              },
              {
                title: "Mobile Number",
                content: (
                  <PhoneWithFlag
                    phone={values?.contact_number}
                    country={{ name: values?.country }}
                    flag={values?.flag}
                  />
                ),
              },
            ];
          }

          return (
            <Form>
              <Breadcrumbs breadCrumbData={breadCrumbData} />
              <Grid2
                container
                spacing={2}
                flexWrap="wrap"
                justifyContent={"space-between"}
                marginTop={"10px"}
              >
                <CommonGrid2 alignItems={"start"} display={"flex"}>
                  {isLoading ? (
                    <HandleSkeletion height={50} width={"300px"} />
                  ) : (
                    <CommonGrid2
                      display={"flex"}
                      flexDirection={"column"}
                      gap={"5px"}
                    >
                      <CommonGrid2
                        display={"flex"}
                        gap={"10px"}
                        flexWrap={"wrap"}
                      >
                        <Typography variant="h3" lineHeight={"normal"}>
                          {values.name}
                        </Typography>
                        <CommonGrid2
                          display={"flex"}
                          gap={"3px"}
                          borderRadius={"50px"}
                          padding={"1px 9px"}
                          alignItems={"center"}
                          width={"max-content"}
                          background={
                            values.rating > 4
                              ? "#36A41D"
                              : values.rating > 2.5
                                ? "#F79009"
                                : "#FF5C77"
                          }
                        >
                          <RatingStarIco />
                          <Typography
                            variant="p"
                            color="#fff"
                            fontWeight={600}
                            fontSize={"13px"}
                          >
                            {values.rating}
                          </Typography>
                        </CommonGrid2>
                        <StatusChange>
                          <DotColor
                            color={
                              values.status === "Active"
                                ? "green"
                                : values.status === "Inactive"
                                  ? "orange"
                                  : "#667085"
                            }
                          />
                          {values.status || "-"}
                        </StatusChange>
                      </CommonGrid2>

                      <Typography variant="p">
                        <b>ID :</b> {values.unique_id}
                      </Typography>
                    </CommonGrid2>
                  )}
                </CommonGrid2>
                <CommonGrid2
                  gap="10px"
                  display="flex"
                  justifyContent={"end"}
                  alignItems={"end"}
                  flexDirection={"column"}
                  height={"fit-content"}
                >
                  <CommonButton
                    value={btnChange.value}
                    padding="8px 2rem"
                    fontWeight="600"
                    type={btnChange.value === "Submit" && "submit"}
                    disabled={btnChange.loading || isLoading}
                    loading={btnChange.loading}
                    onClick={() =>
                      btnChange.value === "Submit" ? {} : handleButtonChange()
                    }
                  />
                </CommonGrid2>
              </Grid2>
              {isOpen && (
                <CommonGrid2
                  display={"flex"}
                  alignItems={"center"}
                  gap={"1rem"}
                  padding={"1rem"}
                  background="#7F56D9"
                  borderRadius={"10px"}
                  marginTop={"1rem"}
                >
                  <img src={CRMHailey} />

                  <CommonGrid2
                    display={"flex"}
                    alignItems={"start"}
                    gap={"5px"}
                    flexDirection={"column"}
                    width={"100%"}
                  >
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      width={"100%"}
                    >
                      <Typography
                        variant="h5"
                        color="#FFFFFF"
                        textTransform="capitalize"
                      >
                        {storageData?.username}
                      </Typography>
                      <CommonButton
                        onClick={handleStepButttonClose}
                        padding={"0px"}
                        minWidth="auto"
                        boxShadow={"none"}
                        customStyle={{
                          justifyContent: "end",
                          "&:hover": { boxShadow: "none" },
                        }}
                        value={<XCloseIco stroke={"#FFFFFF"} size={22} />}
                      />
                    </CommonGrid2>
                    <Typography color="#EBE1F9">
                      This page lets you manage all key details in one place add
                      contact information, view associated jobs and candidates,
                      upload important attachments, and record essential notes
                      to stay organized.
                    </Typography>
                  </CommonGrid2>
                </CommonGrid2>
              )}
              <ApiRender handleFetchCall={handleFetchCall} />
              <Grid2 size={12} marginTop={"1rem"}>
                {btnChange.value === "Edit" ? (
                  <CommonAccordion
                    title={"Basic Info"}
                    icon={<BasicInfoIco />}
                    children={
                      <BasicInfo
                        section_1_data={section_1_data}
                        loading={isLoading}
                        handleCopyClick={handleCopyClick}
                        handleCopyMouseLeave={handleCopyMouseLeave}
                        copied={copied}
                      />
                    }
                  />
                ) : (
                  <ViewBasicInfo
                    basicInfoData={basicInfoData}
                    handleFetchCall={handleFetchCall}
                    isLoading={isLoading}
                  />
                )}
              </Grid2>

              <Typography variant="h3" margin={"2rem 0px"} fontWeight={600}>
                {"Primary Information"}
              </Typography>

              <TabContext value={cardValue.value}>
                <CommonGrid2
                  container
                  spacing={2}
                  alignItems="center"
                  marginTop={2.5}
                >
                  <TabCardSection
                    onChange={handleCardChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="visible arrows tabs example"
                    breakpoint={bounds.width < 890 ? "1450" : "1400"}
                  >
                    {cardData.map((item, index) => (
                      <Tab
                        className={
                          index === 0
                            ? "step-1"
                            : index === 1
                              ? "step-2"
                              : index === 2
                                ? "step-3"
                                : index === 3
                                  ? "step-4"
                                  : "step-5"
                        }
                        value={index}
                        label={
                          <Grid2
                            item
                            key={index}
                            size={12}
                            display={"flex"}
                            flexDirection={"column"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            height={"100%"}
                            gap={"1rem"}
                          >
                            {isLoading ? (
                              <HandleSkeletion
                                width="50px"
                                height="50px"
                                marginRight={"1rem"}
                                transform="scale(1)"
                                borderRadius="50px"
                              />
                            ) : (
                              item?.icon
                            )}
                            {isLoading ? (
                              <HandleSkeletion
                                width="100%"
                                height="30px"
                                transform="scale(1)"
                              />
                            ) : (
                              <CommonGrid2>
                                <Typography
                                  fontSize={"15px"}
                                  fontWeight={600}
                                  color={"#101828"}
                                >
                                  {item.name}
                                </Typography>
                              </CommonGrid2>
                            )}
                          </Grid2>
                        }
                      />
                    ))}
                  </TabCardSection>
                </CommonGrid2>
                <CommonGrid2 style={{ overflow: "hidden" }}>
                  {accordionDataView.map((item, index) => (
                    <Slide
                      direction={
                        cardValue.value > cardValue.prev ? "right" : "left"
                      }
                      in={cardValue.value === index}
                      timeout={500}
                      mountOnEnter
                      unmountOnExit
                    >
                      <TabPanelView value={index} padding="0rem 0px 0px">
                        <CommonGrid2
                          size={12}
                          padding={
                            item.title ? "1rem 0rem" : "2.4rem 0rem 1rem"
                          }
                        >
                          {item.title && (
                            <CommonGrid2
                              display={"flex"}
                              justifyContent={"space-between"}
                              alignItems={"center"}
                              padding={"1rem 0rem"}
                            >
                              <Typography
                                variant="h4"
                                margin={"15px 0px"}
                                fontWeight={600}
                              >
                                {item.title}
                              </Typography>
                              {index === 0 && (
                                <CommonButton
                                  value={"Add New Contact"}
                                  startIcon={<AddIcon />}
                                  padding={"10px 2rem"}
                                  gap={"0px"}
                                  disabled={btnChange.value === "Edit"}
                                  onClick={handleAddNewContact}
                                />
                              )}
                            </CommonGrid2>
                          )}
                          {item.component}
                        </CommonGrid2>
                      </TabPanelView>
                    </Slide>
                  ))}
                </CommonGrid2>
              </TabContext>

              <AddNewContact
                handleButttonClose={handleButttonClose}
                contact={contact}
                setFieldValue={setFieldValue}
                contactValues={values}
                handleInformation={handleInformation}
              />
            </Form>
          );
        }}
      </Formik>
      <AttachmentDialog
        open={attachmentDialog.open}
        handleClose={handleAttachmentClose}
        handleSubmit={handleAttachmentSubmit}
        attachmentDialog={attachmentDialog}
        condition={"CRM"}
      />

      <SkillDeleteDialog
        deleteDialog={deleteButton.open}
        handleDeleteDialogClose={handelAttachmentDialogClose}
        handleDeleteSkill={handleDeleteAttachment}
        buttonLoading={deleteButton.loading}
        title="Delete Attachment"
        content={deleteButton.content}
      />

      <SkillDeleteDialog
        deleteDialog={contact.deleteOpen}
        handleDeleteDialogClose={handleButttonClose}
        handleDeleteSkill={handleDeleteKeyContact}
        buttonLoading={contact.deleteBtnLoading}
        title="Delete Key Contact"
        content={contact.data.name}
      />

      <AddNote
        openNoteDialog={notes.open}
        handleCloseNoteDialog={handleCloseNoteDialog}
        handleCreateNote={handleCreateNote}
        noteList={notes.data}
        notes={notes}
      />

      <DeleteNote
        deleteNoteDialogOpen={notes.deleteNote}
        handleDeleteNoteDialogClose={handleCloseNoteDialog}
        noteList={[notes.noteData]}
        handleDeleteNoteById={handleDeleteNoteById}
        noteLoading={notes.btnLoading}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
};

export default function RelationshipIntelligenceView() {
  return (
    // <TourProvider
    //   steps={steps}
    //   showNavigation
    //   showCloseButton
    //   accentColor="#1976d2"
    //   components={{
    //     Navigation: ({
    //       stepsLength = 0,
    //       currentStep = 0,
    //       setCurrentStep,
    //       setIsOpen,
    //     }) => {
    //       return (
    //         <CommonGrid2
    //           display="flex"
    //           justifyContent="space-between"
    //           marginTop="1rem"
    //           gap="1rem"
    //         >
    //           <CommonButton
    //             value={"Back"}
    //             startIcon={<ArrowBackIcon />}
    //             onClick={() => setCurrentStep(currentStep - 1)}
    //             gap={"0px"}
    //             padding={"4px 15px"}
    //             disabled={currentStep === 0}
    //             fontSize={"13px"}
    //           />

    //           {currentStep < steps.length - 1 ? (
    //             <CommonButton
    //               value={"Next"}
    //               endIcon={<ArrowForwardIcon />}
    //               onClick={() => setCurrentStep(currentStep + 1)}
    //               gap={"0px"}
    //               padding={"4px 15px"}
    //               fontSize={"13px"}
    //             />
    //           ) : (
    //             <CommonButton
    //               value={"Finish"}
    //               background={"green"}
    //               startIcon={<CheckCircleOutlineIcon />}
    //               onClick={() => setIsOpen(false)}
    //               gap={"0px"}
    //               padding={"4px 15px"}
    //               fontSize={"13px"}
    //             />
    //           )}
    //         </CommonGrid2>
    //       );
    //     },
    //   }}
    // >
    <AppContent />
    // </TourProvider>
  );
}
